export function onSwipe(element, { threshold = 50, onSwipeLeft, onSwipeRight } = {}) {
    let startX = 0;

    element.addEventListener('touchstart', (e) => {
      startX = e.changedTouches[0].screenX;
    });

    element.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].screenX;
      const deltaX = endX - startX;
  
      if (Math.abs(deltaX) > threshold) {
        if (deltaX < 0 && typeof onSwipeLeft === 'function') {
          onSwipeLeft();
        } else if (deltaX > 0 && typeof onSwipeRight === 'function') {
          onSwipeRight();
        }
      }
    });
}
